var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGsFlagLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 194,
    height: 194,
    viewBox: "0 0 194 194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97.548,
    height: 57.608,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-703 -3067)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(703 3067)",
    fill: "#fff",
    stroke: "rgba(239,227,212,0.3)",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 97,
    r: 97,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 97,
    r: 95,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(752 3136.196)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.829,
    height: 4.434,
    transform: "translate(47.718 0.017)",
    fill: "#a44148"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.829,
    height: 4.434,
    transform: "translate(47.718 8.88)",
    fill: "#a44148"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.829,
    height: 4.434,
    transform: "translate(47.718 17.739)",
    fill: "#a44148"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.829,
    height: 4.434,
    transform: "translate(47.718 26.598)",
    fill: "#a44148"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97.548,
    height: 4.434,
    transform: "translate(0 35.457)",
    fill: "#a44148"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97.548,
    height: 4.434,
    transform: "translate(0 44.316)",
    fill: "#a44148"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97.548,
    height: 4.434,
    transform: "translate(0 53.174)",
    fill: "#a44148"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46.424,
    height: 31.007,
    transform: "translate(0.014 0)",
    fill: "#214669"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.571,37.58a8.7,8.7,0,0,1-4.151-1.23,2.568,2.568,0,0,0-.769,1.1h-.641V31.943h.743c.231,1.46,1.512,4.227,4.638,4.227,1.717,0,2.767-.948,2.767-2.357,0-1.153-1.332-1.845-2.844-2.665L77.83,29.79a4.718,4.718,0,0,1-2.613-4.3,4.3,4.3,0,0,1,4.561-4.151,5.291,5.291,0,0,1,3.254,1.05,2.558,2.558,0,0,0,.769-1.05h.589v4.919h-.717c-.436-1.973-1.563-3.536-3.767-3.536a1.947,1.947,0,0,0-2.152,1.9c0,1.256,1.1,1.794,2.69,2.639l2.127,1.128c2.229,1.178,3.075,2.69,3.075,4.3a4.828,4.828,0,0,1-5.073,4.894",
    transform: "translate(-44.949 -12.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.736,34.429v1.845c-2.665,0-3.356,1.332-5.868,1.332-4.51,0-7.225-3.664-7.225-8.123s2.9-8.122,7.1-8.122a5.406,5.406,0,0,1,4.3,1.845,2.128,2.128,0,0,0,.692-1.307h.641v5.637h-.692c-.692-3.331-2.408-4.715-4.407-4.715-3.357,0-4.3,3.484-4.3,6.662,0,3.152.743,6.739,4.125,6.739a2.789,2.789,0,0,0,2.947-3.1c0-1.1-.461-1.666-1.973-1.666v-.743h6.38v.743c-1.46,0-1.717.41-1.717,2.973",
    transform: "translate(-6.977 -12.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 21.828,
    transform: "translate(24.18 5.126)",
    fill: "#386c9b"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.04,
    height: 21.828,
    transform: "translate(23.66 5.126)",
    fill: "#386c9b"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGsFlagLogo);
export default __webpack_public_path__ + "static/media/gs_flag_logo.daaf4a6a2039bafc3a3be5ff53f4d4c9.svg";
export { ForwardRef as ReactComponent };